
angular.module('v3sWbtPlayerApp').factory('v3sGsapService', function () {
    function createDraggable(element, options) {
        var draggable = null;

        if (Draggable) {
            draggable = Draggable.create(element, options);
        }

        return draggable;
    }

    function getDraggable(selector) {
        var draggable = null;

        if (Draggable) {
            draggable = Draggable.get(selector);
        }

        return draggable;
    }

    function hitTestDraggable(selector, options) {
        var overlap = false;

        if (Draggable) {
            overlap = Draggable.hitTest(selector, options);
        }

        return overlap;
    }

    return {
        createDraggable: createDraggable,
        getDraggable: getDraggable,
        hitTestDraggable: hitTestDraggable
    }
});
